module.exports = __webpack_public_path__ + "img/img-allies.8a5f8b5.png";